export const GET_ENTRY_QUERY = `
  query GetEntry($id: ID, $paperUuid: String) {
    entry(id: $id, paperUuid: $paperUuid) {
      id
      paperName
      paperUuid
      createdAt
      episode {
        id
        installment
        youtubeLink
        guests
      }
    }
  }
`;

export const GET_ENTRIES_BY_EPISODE_QUERY = `
  query GetEntriesByEpisode($episodeId: ID!) {
    entriesByEpisode(episodeId: $episodeId) {
      id
      paperName
      paperUuid
      createdAt
    }
  }
`;

export const CREATE_ENTRY_MUTATION = `
  mutation CreateEntry($input: CreateEntryMutationInput!) {
    createEntry(input: $input) {
      id
      paperName
      paperUuid
      episode {
        id
        installment
        youtubeLink
        guests
      }
    }
  }
`;

export const UPDATE_ENTRY_MUTATION = `
  mutation UpdateEntry($input: UpdateEntryInput!) {
    updateEntry(input: $input) {
    entry {
      id
      paperName
      paperUuid
      pulledAt
      duration
      createdAt
      episode {
        id
        installment
        youtubeLink
        guests
      }
    }
    errors
    }
  }
`;

export const UPDATE_ENTRY_TO_BUCKET_PULL_MUTATAION = `
  mutation UpdateEntryToBucketPull($input: UpdateEntryToBucketPullInput!) {
    updateEntryToBucketPull(input: $input) {
      entry {
        id
        paperName
        paperUuid
        pulledAt
        createdAt
      }
      errors
    }
  }
`;